import { createSlice, combineReducers } from '@reduxjs/toolkit'
import { loadLogLookups, loadLogs, resetLogs } from './logs.actions'

export interface LogLookupsState {
  status: 'idle' | 'loading' | 'loaded' | 'failed'
  error: null
  data: string[]
}

const initialLogLookupsState = {
  status: 'idle',
  error: null,
  data: [],
}

export const logLookupsReducer = createSlice({
  name: 'logLookups',
  initialState: initialLogLookupsState,
  reducers: {},
  extraReducers: {
    [loadLogLookups.pending.toString()]: (state) => {
      state.status = 'loading'
    },
    [loadLogLookups.fulfilled.toString()]: (state, action) => {
      state.status = 'loaded'
      state.data = action.payload
    },
    [loadLogLookups.rejected.toString()]: (state, action) => {
      state.status = 'failed'
      state.error = action.payload
    },
  },
}).reducer

export interface LogEntriesState {
  status: 'idle' | 'loading' | 'loaded' | 'failed'
  error: null
  data: any[]
  totalPage: number
  uuid: null
}

const initialLogEntriesState: LogEntriesState = {
  status: 'idle',
  error: null,
  data: [],
  totalPage: 0,
  uuid: null,
}

export const logEntriesReducer = createSlice({
  name: 'logEntries',
  initialState: initialLogEntriesState,
  reducers: {},
  extraReducers: {
    [loadLogs.pending.toString()]: (state) => {
      state.status = 'loading'
    },
    [loadLogs.fulfilled.toString()]: (state, action) => {
      state.status = 'loaded'
      state.data.push(action.payload)

      if (action.payload.length !== 0) {
        state.totalPage += 1
      }
    },
    [loadLogs.rejected.toString()]: (state, action) => {
      state.status = 'failed'
      state.error = action.payload
    },
    [resetLogs.toString()]: (_state, action) => {
      return { ...initialLogEntriesState, uuid: action.payload }
    },
  },
}).reducer

export const logsReducer = combineReducers({
  lookups: logLookupsReducer,
  entries: logEntriesReducer,
})
